<template>
  <div class="week-day">
    <div class="top">
      <!-- v-else -->
      <div  class="canteen-name">
        <div class="canteen-title">食堂名称</div>
        <el-select v-model="canteen" placeholder="请选择" class="w200" @change="changeCanteen">
          <el-option
            v-for="item in canteenList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </div>

      <!-- v-if="isCanteenAdmin" -->
      <div>
        <el-button
          v-if="
            OPERATION_LIST.findIndex(
              (item) => item === OPERATIONS_BTNS.roleUpdateMenu
            ) !== -1
          " type="text" class="btn-blue btn-public" @click="release"
          >发布</el-button
        >
        <el-dropdown trigger="click" @command="handleCommand">
          <span class="el-dropdown-link">
            <el-button type="text" class="btn-gray">
              更多
              <i class="el-icon-caret-bottom el-icon--right"></i>
            </el-button>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              :command="beforeHandleCommand('copy')"
              >复制上周</el-dropdown-item
            >
            <el-dropdown-item
              :command="beforeHandleCommand('uploadFoodMenu')"
            >
              <el-upload
                class="upload"
                ref="upload"
                action="#"
                :show-file-list="false"
                :auto-upload="true"
                :before-upload="uploadExcel"
              >
                <span>导入菜谱</span>
              </el-upload>

            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <!-- <el-button plain class="btn-white" @click="copy">复制上周</el-button> -->
      </div>
    </div>
    <div class="week-day-menu">
      <div class="week-menu" v-for="(item, index) in menuList" :key="index">
        <div class="every-day-menu">
          <div>
            <img class="week-name" :src="typeImg[item.dayOfWeek]" />
          </div>
          <div class="date">({{ item.date }})</div>
        </div>
        <div class="week-day-container">
          <div class="third-meal">
            <div class="third-meal-title">
              <div class="third-meal-title-left">
                <span class="breakfase-logo">早</span>
                <span class="sub-title">早餐</span>
              </div>
              <div class="add-meal">
                  <!-- v-if="isCanteenAdmin" -->
                <i
                  class="el-icon-plus"
                  @click="add(index, 1)"
                ></i>
              </div>
            </div>
            <el-carousel
              trigger="click"
              height="92px"
              :autoplay="false"
              :arrow="'always'"
              :loop="false"
            >
              <el-carousel-item
                v-for="(v, idx) in item.breakfase"
                :key="idx"
              >
                <div class="menu-name-content">
                  <div
                    class="menu-name"
                    :class="activeIndex == `${index}-${1}-${vIndex}` ? 'active' : (vIndex + 1) % 3 ? '' : 'no-right'"
                    v-for="(val, vIndex) in v"
                    :key="vIndex"
                    @click="clickFoodName(`${index}-${1}-${vIndex}`)"
                  >
                    <i v-if="activeIndex == `${index}-${1}-${vIndex}`" class="el-icon-error" @click="delBreakfase(index, idx, vIndex)"></i>
                    <div class="food-name">
                      {{ val.name }}
                    </div>
                  </div>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
          <div class="third-meal">
            <div class="third-meal-title">
              <div class="third-meal-title-left">
                <span class="afternoon-logo">午</span>
                <span class="sub-title">午餐</span>
              </div>
              <div class="add-meal">
                  <!-- v-if="isCanteenAdmin" -->
                <i
                  class="el-icon-plus"
                  @click="add(index, 2)"
                ></i>
              </div>
            </div>
            <el-carousel
              trigger="click"
              height="92px"
              :autoplay="false"
              :arrow="'always'"
              :loop="false"
            >
              <el-carousel-item
                v-for="(v, idx) in item.afternoon"
                :key="idx"
              >
                <div class="menu-name-content">
                  <div
                    class="menu-name"
                    :class="activeIndex == `${index}-${2}-${vIndex}` ? 'active' : (vIndex + 1) % 3 ? '' : 'no-right'"
                    v-for="(val, vIndex) in v"
                    :key="vIndex"
                    @click="clickFoodName(`${index}-${2}-${vIndex}`)"
                  >
                    <i v-if="activeIndex == `${index}-${2}-${vIndex}`" class="el-icon-error" @click="delAfternoon(index, idx, vIndex)"></i>
                    <div class="food-name">
                      {{ val.name }}
                    </div>
                  </div>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
          <div class="third-meal dinner">
            <div class="third-meal-title">
              <div class="third-meal-title-left">
                <span class="dinner-logo">晚</span>
                <span class="sub-title">晚餐</span>
              </div>
              <div class="add-meal">
                  <!-- v-if="isCanteenAdmin" -->
                <i
                  class="el-icon-plus"
                  @click="add(index, 3)"
                ></i>
              </div>
            </div>
            <el-carousel
              trigger="click"
              height="92px"
              :autoplay="false"
              :arrow="'always'"
              :loop="false"
            >
              <el-carousel-item v-for="(v, idx) in item.dinner" :key="idx">
                <div class="menu-name-content">
                  <div
                    class="menu-name"
                    :class="activeIndex == `${index}-${3}-${vIndex}` ? 'active' : (vIndex + 1) % 3 ? '' : 'no-right'"
                    v-for="(val, vIndex) in v"
                    :key="vIndex"
                    @click="clickFoodName(`${index}-${3}-${vIndex}`)"
                  >
                    <i v-if="activeIndex == `${index}-${3}-${vIndex}`" class="el-icon-error" @click="delDinner(index, idx, vIndex)"></i>
                    <div class="food-name">
                      {{ val.name }}
                    </div>
                  </div>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </div>
    </div>

    <!-- 新增菜品 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="540px"
      :before-close="handleClose"
    >
      <el-form :model="form" :rules="rules" ref="form">
        <el-form-item label="菜品名称" prop="menuName">
          <el-input class="gray white" v-model="form.menuName"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirm('form')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import FoodMenu from "@/models/menu.js";
import Canteen from "@/models/canteen.js";
import { getWeekDay, formatTimeToDate } from "@/common/js/utils.js";
import { operationMixins } from "@/common/mixins/operation/operation.js";
export default {
  mixins: [operationMixins],
  props: {
    isThisWeek: {
      type: Number
    }
  },
  data() {
    return {
      /* 是否是食堂管理员; 1.是， 0，不是 */
      isCanteenAdmin: 1,
      canteen: "",
      canteenList: [],
      monday: "",
      /* 本周菜单集合 */
      menuList: [],
      /* 上周菜单集合 */
      lastWeekMenuList: [],
      /* 是否复制上周 */
      isLastWeek: '',
      typeImg: {
        周一: require("../assets/Monday.png"),
        周二: require("../assets/Tuesday.png"),
        周三: require("../assets/Wednesday.png"),
        周四: require("../assets/Thursday.png"),
        周五: require("../assets/Friday.png"),
        周六: require("../assets/Saturday.png"),
        周日: require("../assets/Sunday.png"),
      },
      dialogVisible: false,
      dialogTitle: "新增菜品",
      form: {
        menuName: "",
      },
      rules: {
        menuName: [{ required: true, message: "请输入名称", trigger: "blur" }],
      },
      /* 父级下标 */
      parentIndex: "",
      /* 1:早餐; 2.午餐; 3.晚餐; */
      type: "",

      activeIndex: null,

      weekCorrespondingDateList: [],
    };
  },

  async created() {
    if (this.isThisWeek == 1) this.monday = getWeekDay(0);
    if (this.isThisWeek == 2) this.monday = getWeekDay(-7);
    // if (!this.isCanteenAdmin) {
      await this.initCanteenList();
    // }
    this.initMenuList();
    let dayOfWeek = new Date().getDay();
    let days = [7, 1, 2, 3, 4, 5, 6];
    let weekDay = days[dayOfWeek];
    for (let i = 0; i < 7; i++) {
      let mondayInt = new Date().getTime() - ((weekDay-1)*24*3600*1000)
      let weekDic = {
        week: i+1,
        date: mondayInt+(i*24*3600*1000)
      }
      this.weekCorrespondingDateList.push(weekDic)
    }
    console.log(this.weekCorrespondingDateList)
  },

  methods: {
    initMenuList() {
      let canteenId = this.canteen
      let date = this.monday;
      FoodMenu.getMenuList(canteenId, date).then((res) => {
        if (res.success) {
          let arr = [];
          res.result.dayMenuList.map((i) => {
            let obj = {};
            obj.id = i.id;
            obj.date = i.date;
            obj.dayOfWeek = i.dayOfWeek;
            let breakfase = [];
            let afternoon = [];
            let dinner = [];
            i.dishList.map((v) => {
              if (v.type == 1) {
                let breakfastObj = {};
                breakfastObj.type = v.type;
                breakfastObj.name = v.name;
                breakfase.push(breakfastObj);
              }
              if (v.type == 2) {
                let afternoonObj = {};
                afternoonObj.type = v.type;
                afternoonObj.name = v.name;
                afternoon.push(afternoonObj);
              }
              if (v.type == 3) {
                let dinnerObj = {};
                dinnerObj.type = v.type;
                dinnerObj.name = v.name;
                dinner.push(dinnerObj);
              }
            });

            obj.breakfase = this.spitArr(breakfase);
            obj.afternoon = this.spitArr(afternoon);
            obj.dinner = this.spitArr(dinner);
            arr.push(obj);
          });
          if(this.isLastWeek == 1) {
            this.lastWeekMenuList = arr;
            this.lastWeekMenuList.map(v => {
              this.menuList.map(i => {
                if (i.dayOfWeek == v.dayOfWeek) {
                  i.breakfase = v.breakfase
                  i.afternoon = v.afternoon
                  i.dinner = v.dinner
                }
              })
            })
          } else {
            this.menuList = arr;
          }
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },

    spitArr(arr) {
      let newArr = [];
      /* 将一位数组分割成每6个一组 */
      for (let j = 0; j < arr.length; j += 6) {
        newArr.push(arr.slice(j, j + 6));
      }
      return newArr;
    },

    /* 食堂数据 */
    async initCanteenList() {
      let res = await Canteen.getCanteenNoPageList()
      if (res.success) {
        let arr = [];
        res.result.map((i) => {
          let obj = {};
          obj.id = i.id;
          obj.name = i.name;
          arr.push(obj);
        });
        this.canteenList = arr;
        this.canteen = this.canteenList[0].id
      } else {
        this.$message({
          type: "error",
          message: res.message,
        });
      }
    },

    /* 导入菜谱 */
    uploadExcel(file) {
      let formData = new FormData();
      let canteenId = this.canteen
      formData.append("file", file);
      formData.append("canteenId", canteenId);
      Canteen.postUploadFoodMenu(formData).then((res) => {
        if (res.success) {
          this.$message({
            type: "success",
            message: "导入成功",
          });
          this.initMenuList()
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },

    /*
      返回新的command对象
      value即需要传递的额外参数
     */
    beforeHandleCommand(command) {
      return {
        command: command,
      };
    },

    handleCommand(command) {
      switch (command.command) {
        case "copy":
          this.copy()
          break;
      }
    },

    /* 复制上周 */
    copy() {
      this.$confirm(
        "复制上周菜谱？复制会覆盖正在编辑的草稿内容",
        "复制上周提示",
        {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          confirmButtonClass: "btn-blue",
          cancelButtonClass: "btn-gray",
        }
      ).then(() => {
        this.isLastWeek = 1
        if (this.isThisWeek == 1) this.monday = getWeekDay(7);
        if (this.isThisWeek == 2) this.monday = getWeekDay(0);
        this.initMenuList();
      });
    },

    /* 发布 */
    release() {
      let dayMenuList = []
      this.menuList.map((i,index) => {
        let obj = {}
        let date = new Date(this.weekCorrespondingDateList[index].date);
        let year = date.getFullYear()
        obj.date = formatTimeToDate(`${year}.${i.date}`);
        obj.dishList = []
        if (i.breakfase.length > 0) {
          i.breakfase.map(v => {
            v.map(val => {
              obj.dishList.push(val)
            })
          })
        }
        if (i.afternoon.length > 0) {
          i.afternoon.map(v => {
            v.map(val => {
              obj.dishList.push(val)
            })
          })
        }
        if (i.dinner.length > 0) {
          i.dinner.map(v => {
            v.map(val => {
              obj.dishList.push(val)
            })
          })
        }
        dayMenuList.push(obj)
      })
      let data = {
        canteenId: this.canteen,
        dayMenuList
      };
      FoodMenu.postRelease(data).then((res) => {
        if (res.success) {
          this.$message({
            type: "success",
            message: "发布成功",
          });
          this.activeIndex = null
          this.initMenuList();
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },

    add(index, type) {
      this.parentIndex = index;
      this.type = type;
      this.dialogVisible = true;
    },

    handleClose() {
      this.dialogVisible = false;
    },

    clear() {
      this.form.menuName = "";
    },

    confirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let length;
          let list = this.menuList[this.parentIndex];
          let obj = {
            name: this.form.menuName,
            type: this.type,
          };
          if (this.type == 1) {
            length = list.breakfase.length - 1;
            if (list.breakfase.length > 0 && list.breakfase[length].length < 6) {
              list.breakfase[length].push(obj);
            } else {
              let arr = [];
              arr.push(obj);
              list.breakfase.push(arr);
            }
          }
          if (this.type == 2) {
            length = list.afternoon.length - 1;
            if (
              list.afternoon.length > 0 &&
              list.afternoon[length].length < 6
            ) {
              list.afternoon[length].push(obj);
            } else {
              let arr = [];
              arr.push(obj);
              list.afternoon.push(arr);
            }
          }
          if (this.type == 3) {
            length = list.dinner.length - 1;
            if (list.dinner.length > 0 && list.dinner[length].length < 6) {
              list.dinner[length].push(obj);
            } else {
              let arr = [];
              arr.push(obj);
              list.dinner.push(arr);
            }
          }
          this.menuList[this.parentIndex] = list;
          this.handleClose();
          this.clear();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    changeCanteen() {
      this.initMenuList();
    },

    clickFoodName(index) {
      this.activeIndex = index
    },

    delBreakfase(parentIndex, index, childrenIndex) {
      let list = this.menuList[parentIndex].breakfase
      if (list.length > 0) list[index].splice(childrenIndex,1)
    },

    delAfternoon(parentIndex, index, childrenIndex) {
      let list = this.menuList[parentIndex].afternoon
      if (list.length > 0) list[index].splice(childrenIndex,1)
    },

    delDinner(parentIndex, index, childrenIndex) {
      let list = this.menuList[parentIndex].dinner
      if (list.length > 0) list[index].splice(childrenIndex,1)
    }
  },
};
</script>

<style lang='scss'>
.week-day {
  background-color: $bg-white;
  padding-bottom: 20px;
  .top {
    @include flex-end;
    padding: 20px;
    .el-button {
      padding: 0px;
    }
    .canteen-name {
      @include flex-center;
      font-size: $fs-small-l;
      border: 1px solid $bg-ShallowLightSnow;
      margin-right: 20px;
      .canteen-title {
        height: 32px;
        line-height: 32px;
        padding-left: 19px;
        font-weight: 400;
        color: $color-LightGrey;
      }
      .el-input__inner {
        border: none;
      }
    }
    .btn-public {
      margin-right: 14px;
    }
  }
  .week-day-menu {
    padding-right: 20px;
    .week-menu {
      @include flex-start;
      margin-bottom: 20px;
      .every-day-menu {
        width: 96px;
      }
      .week-name {
        width: 58px;
        height: 27px;
        margin-bottom: 5px;
      }
      .date {
        font-size: $fs-medium-s;
        color: $color-BlackGrey;
      }
      .week-day-container {
        flex: 1;
        @include flex-start;
        padding: 20px;
        background: $bg-LightWhiteSmoke;
        .third-meal {
          width: 33.33%;
          background: $bg-white;
          margin-right: 20px;
          overflow-x: hidden;
          .third-meal-title {
            @include flex-between;
            height: 48px;
            border-bottom: 1px solid $bg-ShallowLightSnow;
            .add-meal {
              margin-right: 80px;
              .el-icon-plus {
                color: $color-DepartmentPeople;
              }
            }
            .third-meal-title-left {
              @include flex-start;
            }
            .breakfase-logo,
            .afternoon-logo,
            .dinner-logo {
              display: inline-block;
              width: 24px;
              height: 24px;
              line-height: 24px;
              text-align: center;
              border-radius: 0px 12px 12px 0px;
              font-size: $fs-small-m;
              font-weight: 400;
              color: $color-white;
              margin-right: 13px;
            }
            .breakfase-logo {
              background: $bg-DeepOriginYellow;
            }
            .afternoon-logo {
              background: $bg-PhoneStar;
            }
            .dinner-logo {
              background: $bg-DeepReddishBlue;
            }
            .sub-title {
              font-size: $fs-medium-l;
              font-weight: bold;
              color: $color-BlackGrey;
            }
          }
        }
        .dinner {
          margin-right: 0px;
        }
        .el-carousel--horizontal {
          overflow-x: visible;
        }
        .el-carousel__button {
          width: 4px;
          height: 4px;
          border-radius: 50%;
          background: $bg-SpotGray;
        }
        .el-carousel__arrow {
          width: 16px;
          height: 16px;
          font-size: $fs-medium-s;
          transform: none;
          top: -33px;
          color: $bg-Gainsboro;
          background: transparent;
        }
        .el-carousel__arrow:hover {
          color: $color-DepartmentPeople;
        }
        .el-carousel__arrow--left {
          left: inherit;
          right: 50px;
        }
        .el-carousel__item {
          padding: 0px 20px;
          box-sizing: border-box;
        }
        .menu-name-content {
          @include flex-start;
          flex-wrap: wrap;
        }
        .active {
          border: 1px dashed $bg-DoopLightSnow;
        }
        .menu-name {
          width: 30%;
          height: 28px;
          line-height: 28px;
          margin-top: 6px;
          margin-right: 10px;
          text-align: left;
          position: relative;
          .el-icon-error {
            position: absolute;
            top: -7px;
            right: -7px;
          }
          .food-name {
            width: 100%;
            height: 100%;
            @include two-wrap-ellipsis(1);
          }
        }
        .no-right {
          margin-right: 0px;
        }
      }
    }
  }

  .el-form-item.is-required:not(.is-no-asterisk)
    .el-form-item__label-wrap
    > .el-form-item__label:before,
  .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
    display: none;
  }
  .el-form-item.is-required:not(.is-no-asterisk)
    .el-form-item__label-wrap
    > .el-form-item__label:before,
  .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label::after {
    content: "*";
    color: $bg-Required;
    margin-left: 4px;
  }
  .el-dialog__header,
  .el-dialog__footer {
    border: none;
  }
  .el-dialog__footer {
    @include flex-end;
  }
}
</style>
